import React from 'react';
import { useQuery } from '@apollo/client';
import { Button, Select } from 'antd';
import { RedoOutlined, LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { DIRECTORIES } from '../../graphql/queries/directories';
import { DirectoryProps, DirectoriesData } from '../../types/directory';

const { Option } = Select;

export const SelectDirectory: React.FC<DirectoryProps> = ({ onChange, value }) => {
  const { loading, data = {} as DirectoriesData, refetch } = useQuery<DirectoriesData>(DIRECTORIES);
  const { directories = [] } = data;

  if (loading) return <LoadingOutlined />;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Select
        showSearch
        placeholder="Select directory"
        optionFilterProp="children"
        onChange={onChange}
        value={value}
        filterOption={(input, option) =>
          (option?.label as string).toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {directories.map(({ id, name }) => (
          <Option key={id} value={id} label={name}>
            {name}
          </Option>
        ))}
      </Select>
      <Button
        type="default"
        icon={<RedoOutlined />}
        onClick={() => refetch()}
        style={{ marginLeft: 8 }}
      />
      {value && (
        <Link to={`/directory/${value}`} target="_blank">
          <Button type="primary" style={{ marginLeft: 8 }}>
            Open
          </Button>
        </Link>
      )}
    </div>
  );
};
